// 报名页面
<template>
  <div class="signUp block">
    <h3>{{recruit.title}}</h3>

    <el-form
      class="postSelect"
      ref="postForm"
      :model="postInfo"
      label-width="90px"
    >
      <el-form-item
        label="申请岗位:"
        required
        prop="applyPost"
      >
        <el-select
          v-model="postInfo.applyPost"
          filterable
        >
          <el-option
            v-for="item in recruit.postList"
            :key="item.id"
            :value="item.id"
            :label="item.name"
          >{{item.name}}</el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <c-register-form
      class="signUpForm"
      ref="signUpForm"
      :enrolInfo="enrolInfo"
      :attachments="attachments"
      :extraFields="recruit.extraFields"
    ></c-register-form>
    <div class="submitPanel">
      <a
        @click="submit"
        class="submitBtn"
      >立即报名</a>
    </div>

  </div>
</template>
<script>
import { recruitRes, examineeRes } from '@/api'
import { Promise } from 'q'
export default {
  data() {
    return {
      recruit: {
        title: '',
        postList: [],
        extraFields: []
      },
      //申请岗位
      postInfo: {
        applyPost: '',
      },
      //填报基础信息
      enrolInfo: {},
      //填报附件信息
      attachments: []
    }
  },
  computed: {
    isEdit() {
      //编辑时岗位不可换
      var { isEdit } = this.$route.params
      if (isEdit) {
        return true
      }
      return false
    }
  },
  created() {
    var { id, isEdit, applyId } = this.$route.params

    //是否编辑
    if (isEdit) {
      //根据报名id获取报名信息
      this.getApplyInfo(id, applyId)
    } else {
      this.getRecruitInfo(id)
    }
  },
  methods: {
    //根据招聘id获取招聘信息
    getRecruitInfo(id) {
      var postList = recruitRes.getEnablePostList({ examId: id })
      //招考信息还能不能报名(未开始、已结束、未找到)
      var baseInfo = recruitRes.getEnableDetail({ id })
      var extraFields = recruitRes.getTemplateFields({ examId: id })
      Promise.all([postList, baseInfo, extraFields]).then(
        ([list, detail, extraFields]) => {
          var { isEnable, msg, title } = detail
          if (!isEnable) {
            this.$alert(msg, '提示!', {
              confirmButtonText: '确定',
              type: 'error',
              showClose: false,
              callback: action => {
                this.$router.push('/')
              }
            })
            return
          }

          if (list.length === 0) {
            this.$alert('您暂无剩余岗位可报考', '提示!', {
              confirmButtonText: '确定',
              type: 'warning',
              showClose: false,
              callback: action => {
                this.$router.push('/')
              }
            })
            return
          }

          this.recruit.title =title&& title.replace(/公告|简章/g,'')
          this.recruit.postList = list
          this.recruit.extraFields = extraFields
        }
      )
    },
    //获取报名id获取报名信息
    getApplyInfo(id, applyId) {
      var that = this
      var postList = recruitRes.getPostList({ examId: id })
      //招考信息还能不能报名(未开始、已结束、未找到、未发布)
      var baseInfo = recruitRes.getEnableDetail({ id })
      var extraFields = recruitRes.getTemplateFields({ examId: id })
      var applyDetail = examineeRes.getApplyDetail({ id: applyId })
      Promise.all([postList, baseInfo, extraFields, applyDetail]).then(
        ([list, detail, extraFields, applyDetail]) => {
          var { isEnable, msg, title } = detail
          if (!isEnable) {
            this.$alert(msg, '提示!', {
              confirmButtonText: '确定',
              type: 'error',
              showClose: false,
              callback: action => {
                this.$router.push('/')
              }
            })
            return
          }

          if (applyDetail === null) {
            this.$alert('未找到报名信息', '提示!', {
              confirmButtonText: '确定',
              type: 'error',
              showClose: false,
              callback: action => {
                this.$router.push('/')
              }
            })
            return
          }
          var { applyPost, enrolInfo, attachments } = applyDetail
          this.recruit.title = title
          this.recruit.postList = list
          this.recruit.extraFields = extraFields
          this.postInfo.applyPost = applyPost
          this.enrolInfo = enrolInfo
          this.attachments = attachments
        }
      )
    },
    submit() {
      var { applyId = '' } = this.$route.params
      this.$refs.postForm.validate((valid,errObj) => {
        if (valid) {
          this.$refs.signUpForm.submit().then(res => {
            this.$confirm('信息一旦提交不能更改,请仔细检查(请考生按照报名表要求在对应的栏目填写相关信息，未按栏目要求填写信息的将导致资格审查不通过，后果由考生自行承担)', '提示', {
              confirmButtonText: '准确无误',
              cancelButtonText: '再检查检查',
              type: 'warning'
            }).then(() => {
              //基本信息和附件信息
              var { enrolInfo, attachments } = res
              var id = this.$route.params.id
              var data = {
                id: applyId,
                exam: id,
                applyPost: this.postInfo.applyPost,
                enrolInfo,
                attachments
              }
              //保存
              examineeRes.apply(data).then(res => {
                this.$message.success('报名成功')
                this.$router.push('/')
              })
            })
          })
        }else{
          var that = this;
          for(var i in errObj){
               that.$message.error(errObj[i][0].message)
          }
        }
      })
    }
  }
}
</script>


<style lang="scss" >
.signUp {
  text-align: center;
  width: 100% !important;
  box-sizing: border-box;
  margin: 0 auto 80px auto;
  .extraFields {
    background-color: transparent;
  }
}
.signUpForm {
}

.postSelect {
  text-align: left;
  .el-form-item__error {
    text-align: initial;
  }
}
.postSelect input {
  background-color: transparent;
}
.submitPanel {
  background-color: #cecdcd;
  box-shadow: 0 -1px 30px #cccaca;
  position: fixed;
  left: 256px;
  right: 0;
  bottom: 0;
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  .submitBtn {
    bottom: 0;
    left: 80%;
    right: 0;
    background-color: darkorange;
    width: 40%;
    color: white;
    padding: 15px 0;
  }
}
.sign-up-btn {
  margin-top: 20px;
  padding: 12px 131px;
  background-color: $main_color;
  color: #fff;
}
</style>

